// NoResult.js
import React from 'react';
import truncate from 'lodash/truncate';
import { NamedLink } from '../../../../components';
import { FormattedMessage } from '../../../../util/reactIntl';
import css from './NoResult.module.css';
import StoreContactAndMoreOptions from './StoreContactAndMoreOptions';

const categories = [
  {
    name: (
      <FormattedMessage
        id="PromotionalContent.categoryCampingGear"
        defaultMessage="Camping Gear"
      />
    ),
    items: (
      <FormattedMessage
        id="PromotionalContent.categoryCampingGearItems"
        defaultMessage="Tents, sleeping bags, backpacks, and more."
      />
    ),
  },
  {
    name: (
      <FormattedMessage
        id="PromotionalContent.categorySportsEquipment"
        defaultMessage="Sports Equipment"
      />
    ),
    items: (
      <FormattedMessage
        id="PromotionalContent.categorySportsEquipmentItems"
        defaultMessage="Bicycles, surfboards, kayaks, and fitness gear."
      />
    ),
  },
  {
    name: (
      <FormattedMessage
        id="PromotionalContent.categoryPhotographyEquipment"
        defaultMessage="Photography Equipment"
      />
    ),
    items: (
      <FormattedMessage
        id="PromotionalContent.categoryPhotographyEquipmentItems"
        defaultMessage="Cameras, lenses, tripods, and accessories."
      />
    ),
  },
  {
    name: (
      <FormattedMessage
        id="PromotionalContent.categoryPartySupplies"
        defaultMessage="Party Supplies"
      />
    ),
    items: (
      <FormattedMessage
        id="PromotionalContent.categoryPartySuppliesItems"
        defaultMessage="Tables, chairs, decorations, and audio equipment."
      />
    ),
  },
  {
    name: (
      <FormattedMessage
        id="PromotionalContent.categoryToolsEquipment"
        defaultMessage="Tools and Equipment"
      />
    ),
    items: (
      <FormattedMessage
        id="PromotionalContent.categoryToolsEquipmentItems"
        defaultMessage="Power tools, gardening tools, and construction equipment."
      />
    ),
  },
];

const benefits = [
  {
    title: (
      <FormattedMessage
        id="PromotionalContent.benefitEarnIncomeTitle"
        defaultMessage="Earn Extra Income"
      />
    ),
    description: (
      <FormattedMessage
        id="PromotionalContent.benefitEarnIncomeDesc"
        defaultMessage="Make money from items you already own."
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id="PromotionalContent.benefitReachAudienceTitle"
        defaultMessage="Reach a Wider Audience"
      />
    ),
    description: (
      <FormattedMessage
        id="PromotionalContent.benefitReachAudienceDesc"
        defaultMessage="Connect with renters in your area."
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id="PromotionalContent.benefitFlexibleListingsTitle"
        defaultMessage="Flexible Listings"
      />
    ),
    description: (
      <FormattedMessage
        id="PromotionalContent.benefitFlexibleListingsDesc"
        defaultMessage="Choose your rental terms and availability."
      />
    ),
  },
];

const PromotionContent = ({ intl, storeUserName }) => {
  return (
    <div className={css.emptyStoreMessage}>
      <h4>
        <FormattedMessage
          id="PromotionalContent.greet"
          values={{ name: storeUserName }}
        />
      </h4>
      <h2>
        <FormattedMessage id="PromotionalContent.mainHeading" />
      </h2>
      <p>
        <FormattedMessage id="PromotionalContent.subHeading" />
      </p>
      <ul>
        {categories.map((category, index) => (
          <li key={`category-${index}`}>
            <strong>{category.name}</strong>: {category.items}
          </li>
        ))}
      </ul>
      <h3>
        <FormattedMessage id="PromotionalContent.awarenessMessageTitle" />
      </h3>
      <ul>
        {benefits.map((benefit, index) => (
          <li key={`benefit-${index}`}>
            <strong>{benefit.title}</strong>: {benefit.description}
          </li>
        ))}
      </ul>
      <p>
        <FormattedMessage id="PromotionalContent.readyToStartMessage" />
        <strong>
          <FormattedMessage id="PromotionalContent.addFirstItemMessage" />
        </strong>
        <FormattedMessage id="PromotionalContent.watchRentalMessage" />
      </p>
      <NamedLink className={css.addItemButton} name="NewListingPage">
        <FormattedMessage id="PromotionalContent.createListingButtonText" />
      </NamedLink>
    </div>
  );
};

const CustomerEmptyStore = ({ storeUserName }) => {
  const name = truncate(storeUserName, { length: 30 });
  return (
    <div className={css.customerEmptyStore}>
      <h2 className={css.customerEmptyStoreTitle}>
        <FormattedMessage
          id="StoreProfilePage.customerEmptyStore.title"
          defaultMessage="No items listed yet"
        />
      </h2>
      <p className={css.customerEmptyStoreDescription}>
        <FormattedMessage
          id="StoreProfilePage.customerEmptyStore.description"
          values={{ storeName: name }}
          defaultMessage="{storeName} doesn’t have any rentals listed yet. Check back later or browse other stores on the marketplace."
        />
      </p>
    </div>
  );
};

const NoResult = ({ isCurrentUser, intl, storeUserName, totalListings }) => {
  const hasAnyListings = typeof totalListings === 'number' ? totalListings > 0 : false;
  return (
    <div className={css.emptyStateContainer}>
      {isCurrentUser ? (
        hasAnyListings ? (
          <StoreContactAndMoreOptions storeName={storeUserName} />
        ) : (
          <PromotionContent intl={intl} storeUserName={storeUserName} />
        )
      ) : hasAnyListings ? (
        <StoreContactAndMoreOptions storeName={storeUserName} />
      ) : (
        <CustomerEmptyStore storeUserName={storeUserName} />
      )}
    </div>
  );
};

export default NoResult;
